import { datadogRum } from '@datadog/browser-rum'

let bootStartTime: number | null = null
export const markBootStart = () => {
  if (bootStartTime === null) {
    datadogRum.addTiming('boot_time')
    bootStartTime = Date.now()
  }
}

/**
 * Re-arms the one-shot clock for a SECOND boot-like chain. The deferred legacy registry
 * load is its own boot (flag-on: it happens minutes after the page loaded, in response to
 * the first legacy URL) — without this, `reportBootTiming('legacy_domains_registered')`
 * after `native_domains_registered` is a silent no-op (the first report nulls the clock).
 */
export const restartBootClock = () => {
  bootStartTime = Date.now()
}

export const reportBootTiming = (timingName: string) => {
  if (bootStartTime) {
    // a timing is always relative to the instant the page was opened
    // (inital_load) or route was changed (route_change)
    datadogRum.addTiming(timingName)

    // a duration vital is relative to a start time we choose
    const duration = Date.now() - bootStartTime
    datadogRum.addDurationVital(timingName + '_vital', {
      startTime: bootStartTime,
      duration: duration,
    })

    bootStartTime = null // so it only reports once
  }
}

/**
 * Measures the wall-clock time for all static assets to download.
 * This accounts for parallel downloads - if 5 images download simultaneously,
 * it records 1 unit of time, not 5.
 */
export const trackStaticAssetLoadTime = () => {
  window.addEventListener('load', () => {
    const isStaticAsset = (resource: PerformanceResourceTiming) => {
      const types = ['script', 'link', 'img', 'css', 'other']
      const extensions = /\.(js|css|jpg|jpeg|png|gif|svg|woff|woff2|ttf|eot)$/i

      return types.includes(resource.initiatorType) || extensions.test(resource.name)
    }

    const allResources = performance.getEntriesByType('resource') as PerformanceResourceTiming[]
    const staticAssets = allResources.filter(isStaticAsset)

    if (staticAssets.length > 0) {
      // Find the span from earliest start to latest end
      const earliestStart = Math.min(...staticAssets.map(s => s.startTime))
      const latestEnd = Math.max(...staticAssets.map(s => s.responseEnd))

      datadogRum.addTiming('static_assets_time_start', earliestStart)
      datadogRum.addTiming('static_assets_time_end', latestEnd)
    }
  })
}
